import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/drsr/DRSRList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout.tsx");
